import React from 'react'

import Relazsizes from 'relazsizes'
import isDOMAvailable from 'utils/isDOMAvailable'
import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import { Col } from 'components/qstrap'
import Typography from 'components/atoms/Typography'

import TestimonyCard from 'components/molecules/TestimonyCard'
import ThumbnailSlider from 'components/molecules/ThumbnailSlider'

import config from 'config'

import testimonyData from './testimoniesData.json'

const { assets_url: assetsUrl } = config
const pintariaAssetsPath = `${assetsUrl}/assets/img/pintaria/testimonies`

const PintariaTestimonies = () => (
  <div className="pintaria-testimonies">
    { (isDOMAvailable && window.outerWidth >= 768) ?
      <Relazsizes src={`${pintariaAssetsPath}/bg-top-pc.png`} className="pintaria-testimonies__img-top" /> :
      <Relazsizes src={`${pintariaAssetsPath}/bg-top-sp.svg`} className="pintaria-testimonies__img-top" />
    }
    <SectionContainer
      className="pintaria-testimonies__section"
      paddingTop={120}
      backgroundColor="transparent"
    >
      <Container>
        <Typography component="h2" variant="title" className="text-variant-title-sm text-center">
          Testimoni
        </Typography>
      </Container>
      <ThumbnailSlider>
        {
          testimonyData.map((testimony, idx) => (
            <Col className="pintaria-testimonies__col" md="4" key={`testimony-card-${idx}`}>
              <TestimonyCard
                direction="row"
                {...testimony}
                img={`${assetsUrl}${testimony.img}`}
              />
            </Col>
          ))
        }
      </ThumbnailSlider>
    </SectionContainer>
    { (isDOMAvailable && window.outerWidth >= 768) ?
      <Relazsizes src={`${pintariaAssetsPath}/bg-bottom-pc.svg`} className="pintaria-testimonies__img-bottom" /> :
      <Relazsizes src={`${pintariaAssetsPath}/bg-bottom-sp.svg`} className="pintaria-testimonies__img-bottom" />
    }
    <style jsx global>
      {`
        .pintaria-testimonies {
          position: relative;

          @media screen and (max-width: 767px) {
            background-color: #bcefe2;
          }
          @media screen and (min-width: 768px) {
            background: url('${pintariaAssetsPath}/combined-shape.svg') no-repeat,
                        url('${pintariaAssetsPath}/combined-shape-2.svg') no-repeat,
                        url('${pintariaAssetsPath}/combined-shape-3.svg') no-repeat,
                        #bcefe2 no-repeat;
            background-position: top 35% left, top 25% left 8%, right;
          }
          &__section {
            position: relative;
          }
          &__img-top {
            width: 100%;
            top: -1%;
            position: absolute;
          }
          &__img-bottom {
            top: 99%;
            position: absolute;
            width: 100%;
          }
          .testimony {
            height: 100%;
          }
          &__row {
            display: flex;
            @media screen and (max-width: 767px) {
              display: none !important;
            }
          }
          &__control-button {
            width: 48px;
            height: 48px;
            background: #0fc3c4;
            border-radius: 100%;
            margin: 16px 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border: none;
            &:focus {
              outline: none;
            }
          }
          :global(.ThumbnailSlider) {
            overflow: unset;
          }
          :global(.slick-slider) {
            overflow: hidden;
          }
          :global(.slick-arrow) {
            top: 50%;
          }
          :global(.slick-track) {
            display: flex;
            max-height: none;
          }
          :global(.slick-slide) {
            height: inherit;
          }
          :global(.slick-slide > div) {
            height: 100%;
          }
          &__col {
            height: 100%;
          }
        }
      `}
    </style>
  </div>
)

export default PintariaTestimonies
